import { styled } from '@mui/material';
import { Box } from 'shared/mui/Box';

export const StatusRowStyled = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const StatusLeftStyled = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const ProgressWrapperStyled = styled(Box)({
  marginTop: '8px',
  color: '#bdbdbd',
});
